import AppGridContainer from "@crema/core/AppGridContainer";
import { Box, Button, FormHelperText, Grid, TextField } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
    createPolicyManuals,
    updatePolicyManuals,
} from "redux/actions/Policies";
const validationSchema = yup
    .object()
    .shape({
        title: yup
            .string()
            .trim()
            .required("Please enter title")
            .min(2, "Title should be greater than 2 characters")
            .max(255, "Title should be less than 255 characters"),
    })
    .required();
export default function AddManual(props) {
    const dispatch = useDispatch();
    const { setOpen, action, editRow } = props;
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema),
        defaultValues: {
            title: "",
        },
    });
    const onSubmit = (data) => {
        data.type = "MANUAL";
        if (action.add === true) {
            dispatch(createPolicyManuals(data)).then((res) => {
                if (res.httpStatus === "OK") {
                    setOpen(false);
                }
            });
        } else if (action.edit === true) {
            dispatch(updatePolicyManuals(editRow.id, data)).then((res) => {
                if (res.httpStatus === "OK") {
                    setOpen(false);
                }
            });
        }
    };

    React.useEffect(() => {
        if (action.edit === true) {
            const fields = ["title"];
            fields.forEach((field) => {
                setValue(field, editRow[field]);
            });
        }
    }, [action]);

    return (
        <Box>
            <form onSubmit={handleSubmit(onSubmit)}>
                <AppGridContainer spacing={4} sx={{ pt: 2 }}>
                    <Grid item xs={12}>
                        <Controller
                            control={control}
                            name="title"
                            render={({ field }) => (
                                <TextField
                                    type="text"
                                    fullWidth
                                    label="Title*"
                                    id="title"
                                    variant="outlined"
                                    {...field}
                                />
                            )}
                        />
                        <FormHelperText error={true}>
                            {errors?.title?.message}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Button
                                color="primary"
                                variant="outlined"
                                sx={{
                                    mr: 2,
                                }}
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button variant="contained" type="submit">
                                Submit
                            </Button>
                        </Box>
                    </Grid>
                </AppGridContainer>
            </form>
        </Box>
    );
}

AddManual.propTypes = {
    setOpen: PropTypes.func.isRequired,
    action: PropTypes.func.isRequired,
    editRow: PropTypes.object.isRequired,
};
